import { render, staticRenderFns } from "./one-station-hill.vue?vue&type=template&id=83c56c06&"
import script from "./one-station-hill.vue?vue&type=script&lang=js&"
export * from "./one-station-hill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports